var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuListResidentialCollege(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    id: "svg453",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs457",
    fill: "#246abf"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath467",
    fill: "#246abf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,24 H 24 V 0 H 0 Z",
    id: "path465",
    fill: "#246abf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g459",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g463",
    clipPath: "url(#clipPath467)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g469",
    transform: "translate(18.5,17.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 2.209,0 4,-1.791 4,-4 v -10 c 0,-1.104 -0.896,-2 -2,-2 h -17 c -1.104,0 -2,0.896 -2,2 v 10 c 0,2.209 1.791,4 4,4 z",
    className: "path-style-residential-college"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g473",
    transform: "translate(22.5,12.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -2.843 c -1.061,0 -2.078,0.422 -2.828,1.172 l -2.708,2.707 c -1.171,1.171 -3.071,1.171 -4.242,0 L -15.329,1.172 C -16.079,0.422 -17.096,0 -18.157,0 H -21",
    className: "path-style-residential-college"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g477",
    transform: "translate(5.5,6.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 1",
    className: "path-style-residential-college"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g481",
    transform: "translate(17.5,6.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 1",
    className: "path-style-residential-college"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g485",
    transform: "translate(10.5,12.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0,0.828 0.671,1.5 1.5,1.5 2.329,1.5 3,0.828 3,0 3,-0.828 2.329,-1.5 1.5,-1.5 0.671,-1.5 0,-0.828 0,0",
    className: "circle-style-residential-college"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g489",
    transform: "translate(10,1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 5.5 c 0,1.104 0.896,2 2,2 1.104,0 2,-0.896 2,-2 V 0",
    className: "rect-style-residential-college"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g493",
    transform: "translate(15.8569,19.9521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 1.478,0.493 1.472,2.585 -0.008,3.069 l -2.519,0.825 c -0.218,0.101 -0.454,0.154 -0.694,0.154 -0.904,0 -1.636,-0.733 -1.636,-1.636 v -3.364 -1 c 0,-0.553 0.448,-1 1,-1 0.552,0 1,0.447 1,1 v 1 z",
    className: "rect-style-residential-college"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuListResidentialCollege);
export default __webpack_public_path__ + "static/media/menu_list-residential_college.e00cd6329493597b518a753348965352.svg";
export { ForwardRef as ReactComponent };